import { useIntl } from 'react-intl';
import { canvasService } from '../../../apiServices/CanvasService';
import { ConfirmModal } from '../../../components/Modal/ConfirmModal';

type GarbageCollectModalProps = {
  canvasId: string;
  canvasName: string;
  changeCount: number;
  onSuccess: () => void;
};

export const GarbageCollectModal = ({
  canvasId,
  canvasName,
  changeCount,
  onSuccess,
}: GarbageCollectModalProps) => {
  const intl = useIntl();

  const onGarbageCollect = () =>
    canvasService
      .garbageCollectCanvas(canvasId)
      .then(({ message, deletedChanges }) => {
        onSuccess();
        return intl.formatMessage(
          { id: 'admin.garbageCollect.successToast' },
          { message, count: deletedChanges }
        );
      });

  return (
    <ConfirmModal
      title={intl.formatMessage({ id: 'admin.garbageCollect.title' })}
      description={intl.formatMessage({ id: 'admin.garbageCollect.warning' })}
      variant="danger"
      confirmLabel={intl.formatMessage({
        id: 'admin.garbageCollect.confirmButton',
      })}
      confirmingLabel={intl.formatMessage({
        id: 'admin.garbageCollect.loadingButton',
      })}
      cancelLabel={intl.formatMessage({ id: 'admin.copyProject.cancelButton' })}
      onConfirm={onGarbageCollect}
    >
      <p>
        {intl.formatMessage(
          { id: 'admin.garbageCollect.confirmText' },
          { name: <strong>{canvasName}</strong> }
        )}
      </p>
      <p>
        {intl.formatMessage(
          { id: 'admin.garbageCollect.changesCount' },
          { count: <strong>{changeCount}</strong> }
        )}{' '}
        {intl.formatMessage({ id: 'admin.garbageCollect.description' })}
      </p>
    </ConfirmModal>
  );
};
